/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_Rules_EyebrowInputs */

const en_directory_guide_rules_eyebrow = /** @type {(inputs: Directory_Guide_Rules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission rules`)
};

const zh_directory_guide_rules_eyebrow = /** @type {(inputs: Directory_Guide_Rules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交规则`)
};

/**
* | output |
* | --- |
* | "Submission rules" |
*
* @param {Directory_Guide_Rules_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_rules_eyebrow = /** @type {((inputs?: Directory_Guide_Rules_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_Rules_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_rules_eyebrow(inputs)
	return zh_directory_guide_rules_eyebrow(inputs)
});
export { directory_guide_rules_eyebrow as "directory.guide.rules.eyebrow" }